import {products} from "../store"
import {Products} from "../../services/products";
import {fallbackProducts} from "../../utils/fallbackProducts";

export default function setPreviewProducts(id: string) {
    Products.geProductByIds()
        .then(res => {
            if (res.items && res.items.length > 0) {
                products.set({[id]: res.items})
            } else {
                products.set({[id]: fallbackProducts.products})
            }

        })
        .catch(err => console.log(err))

}
